<section class="lms-modal-frame" [style.--lms-modal-frame-min-width]="cssMinWidth" [style.--lms-modal-frame-max-width]="cssMaxWidth">
  <header class="lms-modal-frame__header" *ngIf="title">
    <app-page-cardhead [PageName]="title" [PageHeadWidth]="pageHeadWidth"></app-page-cardhead>
  </header>

  <div class="lms-modal-frame__body">
    <ng-content select="[modal-body]"></ng-content>
  </div>

  <footer class="lms-modal-frame__footer">
    <div class="lms-modal-frame__actions">
      <ng-content select="[modal-actions]"></ng-content>
    </div>
  </footer>
</section>
